import "./fatal.css";

let shown = false;

/**
 * Shows an error screen with a Reload button above the page. The first message stays, because
 * the first failure is usually the cause of the failures after it.
 */
export function showFatal(message: string): void {
  if (shown) return;
  shown = true;

  const screen = document.createElement("div");
  screen.className = "fatal";

  const text = document.createElement("p");
  text.className = "fatal-message";
  text.setAttribute("role", "alert");
  text.textContent = message;

  const reload = document.createElement("button");
  reload.type = "button";
  reload.className = "fatal-reload";
  reload.textContent = "Reload";
  reload.addEventListener("click", () => window.location.reload());

  screen.append(text, reload);
  document.body.append(screen);
}
